import { render, staticRenderFns } from "./GoogleSlidesContent.vue?vue&type=template&id=0b296bfc&scoped=true&"
import script from "./GoogleSlidesContent.vue?vue&type=script&lang=js&"
export * from "./GoogleSlidesContent.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSlidesContent.vue?vue&type=style&index=0&id=0b296bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b296bfc",
  null
  
)

export default component.exports